// Uncomment the following lines to import the desired Bootstrap JavaScript components

import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';

import './index.scss';

document.addEventListener('DOMContentLoaded', () => import('shared/toasts/toasts'));

document.addEventListener('DOMContentLoaded', async () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  if (tooltipTriggerList.length > 0)
    import('bootstrap/js/dist/tooltip').then(({ default: Tooltip }) =>
      tooltipTriggerList.forEach(
        tooltipTriggerEl => new Tooltip(tooltipTriggerEl, { container: 'main' })
      )
    );
});
